export const MAX_NAME_LENGTH = 50
export const MAX_COMMENT_LENGTH = 40
export const MAX_EXTERNAL_ID_LENGTH = 40
export const MAX_CHARGEPOINT_DESCRIPTION_LENGTH = 100
export const MAX_CHARGEPOINT_PARTNER_DESCRIPTION_LENGTH = 200
export const MAX_WIFI_SSID_LENGTH = 64
export const MAX_WIFI_PASSWORD_LENGTH = 64
export const MAX_ORG_EMAIL_LENGTH = 50
export const MAX_ORG_DESC_LENGTH = 250
export const MAX_ORG_PHONE_NO_LENGTH = 50
export const MAX_ORG_CONTACT_PERSON_LENGTH = 100
export const MAX_ORG_ADDRESS_1_LENGTH = 100
export const MAX_ORG_ADDRESS_2_LENGTH = 100
export const MAX_ORG_COMMENT_LENGTH = 500
